import { Modal } from "react-bootstrap";
import React, { useEffect, useRef, useState } from "react";
import Button from "../../components/Buttons/Button";
import {
  CODE_CLOSE_MODAL_SUCCESS,
  CODE_EMAIL_VERIFICATION,
  CODE_PASSWORD_RESET,
  CODE_ROUTE_TO_SIGNUP,
  ROUTE_CREATE_ACCOUNT,
} from "../../constants";
import { customerBusinessService } from "../../services";
import { Toast_Func } from "../../helpers/toast.helper";
import { IAccountStatus } from "../../models/misc";
import { useNavigate } from "react-router";

interface IAccountStatusModalProps {
  accountStatusModal: IAccountStatus;
  updateAccountStatusModal: (
    header: string, 
    text: string, 
    code: number, 
    buttonText: string, 
    email: string, 
    isError: boolean
    ) => void;
  closeModal: () => void;
}

const AccountStatusModal: React.FC<IAccountStatusModalProps> = ({
  accountStatusModal: { show, email, header, text, isError, buttonText, code },
  closeModal,
  updateAccountStatusModal,
}) => {
  const history = useNavigate();
  const [isSendingEmail, setIsSendingEmail] = useState<boolean>(false);
  const bodyTextSpanRef = useRef(null);
  useEffect(() => {
    if (bodyTextSpanRef.current)
      bodyTextSpanRef.current.innerText = text;
  }, [bodyTextSpanRef, text])

  const sendPasswordResetEmail = async () => {
    try {
      setIsSendingEmail(true);
      const response = await customerBusinessService.resetPassword({
        email: email,
        platform: "web",
      });
      updateAccountStatusModal(
        response.data.data.header, 
        response.data.data.text, 
        CODE_CLOSE_MODAL_SUCCESS,
        "Done",
        email,
        false,
      );
    } catch (error) {
      Toast_Func({
        status: false,
        message: error.response.data?.errors?.[0],
      });
    } finally {
      setIsSendingEmail(false);
    }
  };

  const resendVerificationEmail = async () => {
    try {
      setIsSendingEmail(true);
      const response = await customerBusinessService.resendVerificationEmail({
        email: email,
        platform: "web",
      });
      updateAccountStatusModal(
        response.data.data.header, 
        response.data.data.text, 
        CODE_CLOSE_MODAL_SUCCESS,
        "Done",
        email,
        false,
      );
    } catch (error) {
      Toast_Func({
        status: false,
        message: error.response.data?.errors?.[0],
      });
    } finally {
      setIsSendingEmail(false);
    }
  };

  return (
    <Modal
      show={show}
      centered
      className="theme-modal-style app_container_wrap  border-radius-15 px-5 order_type_modal"
      onHide={closeModal}
      size="sm"
    >
      <Modal.Header className="x-4 justify-content-center">
        <button
          type="button"
          className="btn modal-close-button pe-0 sm-blue-icon"
          onClick={closeModal}
        >
          Close
        </button>
      </Modal.Header>
      <Modal.Body className="px-5">
        <>
          <h4 className="f-s22 font-Cls text-center fw-normal lh-normal mb-0 text-capitalize">
            {header}
          </h4>
          <div className="w-100 mx-auto px-1">
            <div className="justify-content-center my-3">
              <span className="d-block f-s14 font-Visby-cf f-w5 text-center" ref={bodyTextSpanRef}>
              </span>
              {/* <span className="d-block f-s14 font-Visby-cf f-w5 font-weight-bold">
                {email}
              </span> */}
            </div>
          </div>
          {buttonText && (
            <div className="justify-content-center app_container_wrap px-1 py-2 text-center">
              <div className="text-center">
                <Button
                  type="button"
                  className="btn btn-large mb-sm-4 mb-3 d-block mx-auto"
                  onClick={() => {
                    if (code === CODE_CLOSE_MODAL_SUCCESS)
                      closeModal();
                    else if (code === CODE_ROUTE_TO_SIGNUP)
                      history(ROUTE_CREATE_ACCOUNT)
                    else if (code === CODE_PASSWORD_RESET)
                      sendPasswordResetEmail();
                    else if (code === CODE_EMAIL_VERIFICATION)
                      resendVerificationEmail();
                  }}
                  disabled={isSendingEmail}
                  loading={isSendingEmail}
                >
                  {buttonText}
                </Button>
              </div>
            </div>
          )}
        </>
      </Modal.Body>
    </Modal>
  );
};

export default AccountStatusModal;
